import { composeIO } from 'react-compose-io'
import { controleComissaoPedidoIO } from './ControleComissaoPedido.IO'
import { ControleComissaoPedidoView } from './ControleComissaoPedido.View'

export const ControleComissaoPedido = composeIO(ControleComissaoPedidoView, controleComissaoPedidoIO)
